import RootState from 'typings/RootState'
import { Event } from 'Store/common/common.types'
import { ListData, GrnData, LatestGrnData, CountData, ImproveListData } from './types'

export const selectGrnListEvent = (state: RootState): Event => state.grnReducer.listEvent

export const selectGrnImproveList = (state: RootState): ImproveListData => state.grnReducer.improveList

export const selectGrnList = (state: RootState): ListData => state.grnReducer.list

export const selectGrnActionEvent = (state: RootState): Event => state.grnReducer.actionEvent

export const selectGrnDetail = (state: RootState): GrnData | undefined => state.grnReducer.detail

export const selectGrnDetailEvent = (state: RootState): Event => state.grnReducer.detailEvent

export const selectLastCreateID = (state: RootState): number => state.grnReducer.lastCreateID

export const selectGrnListBySupEvent = (state: RootState): Event => state.grnReducer.listBySupplierEvent

export const selectGrnListBySub = (state: RootState): ListData => state.grnReducer.listBySupplier

export const selectLatestGrn = (state: RootState): LatestGrnData | undefined => state.grnReducer.lastesGrn

export const selectLatestGrnList = (state: RootState): LatestGrnData[] | undefined =>
  state.grnReducer.lastesGrnList

export const selectCountData = (state: RootState): CountData | undefined => state.grnReducer.countData
